import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NotFoundPageComponent } from './not-found-page/not-found-page.component';
import { HttpStatusService } from '@app/core/http-status.service';
import { RuntimeEnvironmentService } from '@app/core/runtime-environment.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiHostInterceptorService } from '@app/core/http-interceptors/api-host-interceptor.service';
import { TransferStateInterceptorService } from '@app/core/http-interceptors/transfer-state-interceptor.service';
import { AuthInterceptorService } from '@app/core/http-interceptors/auth-interceptor.service';
import { AuthGuard } from '@app/core/auth-guard.service';
import { GoogleTagManagerService } from '@app/core/angulartics/google-tag-manager.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RavenLoggerService } from '@app/core/raven/raven-logger.service';
import { EmptySiteComponent } from '@app/core/empty-site/empty-site.component';
import { InlineSVGModule } from 'ng-inline-svg';
import {
  AuthService,
  CheckpointService,
  CouponsService,
  EventsService,
  FaqService,
  FederalSubjectsService,
  FeedbackService,
  FullPageService,
  NewsService,
  PublishedFeedbacksService,
  PartnersService,
  SocialSupportService,
  TokenStorageService,
  VolunteerSupportService,
  VouchersService,
  AgreementService,
  ConfigService,
} from '@app/core/services';
import { GuestGuard } from '@app/core/guest-guard.service';
import { PollService } from '@app/core/services/poll.service';
import { SearchService } from '@app/core/services/search.service';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    InlineSVGModule,
  ],
  declarations: [
    NotFoundPageComponent,
    EmptySiteComponent,
  ],
  providers: [
    AuthGuard,
    GuestGuard,
    AuthService,
    CheckpointService,
    CouponsService,
    FaqService,
    FederalSubjectsService,
    FeedbackService,
    FullPageService,
    GoogleTagManagerService,
    HttpStatusService,
    PartnersService,
    RavenLoggerService,
    RuntimeEnvironmentService,
    SocialSupportService,
    TokenStorageService,
    VolunteerSupportService,
    VouchersService,
    NewsService,
    EventsService,
    AgreementService,
    PublishedFeedbacksService,
    ConfigService,
    PollService,
    SearchService,

    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiHostInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TransferStateInterceptorService,  // this interceptor should be the latest one
      multi: true,
    },
  ],
})
export class CoreModule { }



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts